import { render } from "./TransformFields.vue?vue&type=template&id=1871d684&scoped=true"
import script from "./TransformFields.vue?vue&type=script&lang=js"
export * from "./TransformFields.vue?vue&type=script&lang=js"

import "./TransformFields.vue?vue&type=style&index=0&id=1871d684&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1871d684"],['__file',"src/components/flow/evaluate/data-transform/TransformFields.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1871d684"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1871d684', __exports__)) {
    api.reload('1871d684', __exports__)
  }
  
  module.hot.accept("./TransformFields.vue?vue&type=template&id=1871d684&scoped=true", () => {
    api.rerender('1871d684', render)
  })

}


export default __exports__